import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { LoginRequest, RegisterRequest, RefreshTokenRequest, UpdateUserRequest,ForgotPasswordRequest, SetPasswordRequest, UserAdminListParams, PlatformPersonaSlug } from '../types/auth.type';

export const loginUser = (user: LoginRequest) => {
    return makeRequest({
        url: "/user/login",
        method: HttpMethods.POST,
        data: user,
    });
};

export const registerUser = (data: RegisterRequest) => {
    return makeRequest({
        url: "/user/register",
        method: HttpMethods.POST,
        data,
    });
};

export const refreshToken = (data: RefreshTokenRequest) => {
    return makeRequest({
        url: "/app_user/refresh_token",
        method: HttpMethods.POST,
        data,
    });
};

export const getCurrentUser = () => {
    return makeRequest({
        url: "/user/me",
        method: HttpMethods.GET,
    });
};

export const getUsers = (organizationId?: string) => {
    const url = organizationId ? `/user/${organizationId}` : '/user';
    return makeRequest({
        url,
        method: HttpMethods.GET,
    });
};

export const listPlatformUsers = (params: UserAdminListParams = {}) => {
    const query: Record<string, string | number> = {
        page: params.page ?? 1,
        limit: params.limit ?? 20,
    };
    if (params.status) {
        query.status = params.status;
    }
    if (params.search?.trim()) {
        query.search = params.search.trim();
    }
    if (params.organizationId) {
        query.organization_id = params.organizationId;
    }
    return makeRequest({
        url: '/user/admin',
        method: HttpMethods.GET,
        params: query,
    });
};

export const getUser = (userId: string) => {
    return makeRequest({
        url: `/user/${userId}`,
        method: HttpMethods.GET,
    });
};

export const updateUser = (organizationId: string, userId: string, data: UpdateUserRequest) => {
    return makeRequest({
        url: `/user/${organizationId}/${userId}`,
        method: HttpMethods.PUT,
        data,
    });
};

export const replaceUserCollectionSites = (
    organizationId: string,
    userId: string,
    collection_site_ids: string[]
) => {
    return makeRequest({
        url: `/user/${organizationId}/${userId}/sites`,
        method: HttpMethods.PUT,
        data: { collection_site_ids },
    });
};

export const deleteUser = (userId: string) => {
    return makeRequest({
        url: `/user/${userId}`,
        method: HttpMethods.DELETE,
    });
};

export const createUser = (data: RegisterRequest) => {
    return makeRequest({
        url: `/user/register`,
        method: HttpMethods.POST,
        data,
    });
};

export const forgotPassword = (data: ForgotPasswordRequest) => {
    return makeRequest({
        url: "/user/forgot-password",
        method: HttpMethods.POST,
        data,
    });
};

export const setUserPassword = (userId: string, data: SetPasswordRequest) => {
    return makeRequest({
        url: `/user/${userId}/password`,
        method: HttpMethods.PUT,
        data,
    });
};

export const fetchPlatformPersonaCatalog = () => {
    return makeRequest({
        url: '/user/admin/platform-personas/catalog',
        method: HttpMethods.GET,
    });
};

export const getUserPlatformPersonas = (userId: string) => {
    return makeRequest({
        url: `/user/admin/${userId}/platform-personas`,
        method: HttpMethods.GET,
    });
};

export const replaceUserPlatformPersonas = (userId: string, personas: PlatformPersonaSlug[]) => {
    return makeRequest({
        url: `/user/admin/${userId}/platform-personas`,
        method: HttpMethods.PUT,
        data: { personas },
    });
};
